const THUMBOR_SERVER_HOSTNAME = 'https://evenfinancial.com'

interface ThumborFilters {
	backgroundColor?: string
	format?: 'webp' | 'jpeg'
}

export interface ThumborOptions {
	trim?: boolean
	trimTolerance?: number
	width?: number
	height?: number
	fitType?: 'full' | 'adaptive'
	highQuality?: boolean
	filters?: ThumborFilters
}

export const ThumborDefaults: Partial<ThumborOptions> = { trim: true, trimTolerance: 100, fitType: 'full' }

export const thumborLink = (
	url: string,
	{ trim, width, height, fitType, highQuality, filters, trimTolerance }: ThumborOptions = {}
	// eslint-disable-next-line sonarjs/cognitive-complexity
): string => {
	const segments: string[] = [THUMBOR_SERVER_HOSTNAME, 'unsafe']
	if (trim) {
		segments.push(`trim:top-left:${trimTolerance || 0}`)
	}
	if (width || height) {
		let fitPath = ''
		if (fitType) {
			fitPath += `${fitType}-`
		}
		fitPath += 'fit-in/'
		if (width && height) {
			const multiplier = highQuality ? 1.8 : 1.2
			fitPath += `${width * multiplier}x${height * multiplier}`
			segments.push(fitPath)
		}
	}
	if (filters) {
		let filterPath = 'filters'
		if (filters.format) {
			filterPath += `:format(${filters.format})`
		}
		if (filters.backgroundColor) {
			filterPath += `:background_color(${filters.backgroundColor})`
		}
		segments.push(filterPath)
	}
	segments.push(url)

	return segments.join('/')
}
